export const InitGTM = () => {
  const init = function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;

    // ZW-326 added new GTM link and created specific option for India
    j.src = 'https://gtm.zerobounce.net/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  };

  const isDev = process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === 'xyz' || process.env.REACT_APP_ENV === 'test';

  if (!isDev) {
    // GTM-PTHNHJM is the Google Tag Manager id for .net and .net/es . However, do not confuse it with the Google Analytics version 4 (which, unlike the GTM, is separate for .net and .net/es and is a different thing with a different id). The Google Analytics 4 is now added by the marketing team. See ZW-228 comments in Jira
    return init(window, document, 'script', 'dataLayer', 'GTM-PTHNHJM');
  }
};
